/**
 * List/Grid view toggle
 * Story 226: Projects Dashboard
 */

import './ViewToggle.css';

export type ViewMode = 'list' | 'grid';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (mode: ViewMode) => void;
}

export function ViewToggle({ value, onChange }: ViewToggleProps) {
  return (
    <div className="view-toggle" role="group" aria-label="View mode">
      <button
        className={`view-toggle__button ${value === 'list' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onChange('list')}
        type="button"
        aria-pressed={value === 'list'}
        title="List view"
      >
        <svg viewBox="0 0 16 16" fill="currentColor" className="view-toggle__icon">
          <path d="M2 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zm3.75-1.5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zm0 5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zm0 5a.75.75 0 0 0 0 1.5h8.5a.75.75 0 0 0 0-1.5h-8.5zM3 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
        </svg>
      </button>
      <button
        className={`view-toggle__button ${value === 'grid' ? 'view-toggle__button--active' : ''}`}
        onClick={() => onChange('grid')}
        type="button"
        aria-pressed={value === 'grid'}
        title="Grid view"
      >
        <svg viewBox="0 0 16 16" fill="currentColor" className="view-toggle__icon">
          <path d="M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zm8 0A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm-8 8A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm8 0A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3z" />
        </svg>
      </button>
    </div>
  );
}
